// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DocumentUtils } from '@shared/utils/DocumentUtils';
import { VerticalPanelColoringTypes } from '../../../VerticalGroupedPanels/VerticalPanelColoringTypes';
import { StringUtils } from '@shared/utils/StringUtils';
class RowItemDataArray {
    constructor(values, isValid) {
        this.values = values.filter(isValid);
    }
    get firstValue() {
        var _a;
        return (_a = this.values[0]) !== null && _a !== void 0 ? _a : null;
    }
    get secondValue() {
        var _a;
        return (_a = this.values[1]) !== null && _a !== void 0 ? _a : null;
    }
    isValid() {
        return this.values.length > 0;
    }
    isSingle() {
        return this.values.length === 1;
    }
}
export class RowItemDataStringArray extends RowItemDataArray {
    constructor(...values) {
        super(values, isValidString);
    }
    isNAString() {
        return this.isSingle() && this.values[0] === StringUtils.NOT_AVAILABLE;
    }
    toString() {
        return this.values.join('/');
    }
}
export class RowItemDataNumberArray extends RowItemDataArray {
    constructor(...values) {
        super(values, (value) => !isNullOrUndefined(value));
    }
}
export class RowItemDataColorArray extends RowItemDataArray {
    constructor(dataForColoring, coloringType) {
        var _a;
        const coloringHandler = getColoringMethod(coloringType);
        const colors = (_a = dataForColoring === null || dataForColoring === void 0 ? void 0 : dataForColoring.values.map(coloringHandler)) !== null && _a !== void 0 ? _a : [DocumentUtils.TABLE_WHITE];
        super(colors, isValidString);
    }
}
const getColoringMethod = (coloringType) => {
    return coloringType === VerticalPanelColoringTypes.LiveLeverage
        ? DocumentUtils.getColorTableForLiveLeverage
        : DocumentUtils.getColorTableStyle;
};
